import { Inject, Injectable } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { FLOCK_VARIANT, FlockVariant } from 'src/app/flock/models/flock.model';
import { Environment } from 'src/environments/environment.model';

@Injectable({
  providedIn: 'root',
})
export class LayerBackendService {
  readonly legacyBaseUrl = `${this.env.API_BASE_URL}/service/layer-registration/secure`;
  readonly poultryBaseUrl = `${this.env.APIM_BASE_URL}/poultry-service`;

  constructor(@Inject(EnvironmentInjector) private readonly env: Environment) {}

  get isPoultryEnabled(): boolean {
    return Boolean(
      (this.env as Environment & { USE_POULTRY_SERVICE?: boolean }).USE_POULTRY_SERVICE,
    );
  }

  getFlockBaseUrl(variant: FlockVariant = FLOCK_VARIANT.Layer): string {
    const animalPath = `${variant}s`;
    return this.isPoultryEnabled
      ? `${this.poultryBaseUrl}/${animalPath}/flocks`
      : `${this.legacyBaseUrl}/flock`;
  }

  get flockBaseUrl(): string {
    return this.getFlockBaseUrl();
  }

  getFlockWeekDataBaseUrl(variant: FlockVariant = FLOCK_VARIANT.Layer): string {
    return this.isPoultryEnabled
      ? this.getFlockBaseUrl(variant)
      : `${this.legacyBaseUrl}/FlockWeekData`;
  }

  get flockWeekDataBaseUrl(): string {
    return this.getFlockWeekDataBaseUrl();
  }

  getAnimalCountBaseUrl(variant: FlockVariant = FLOCK_VARIANT.Layer): string {
    return this.isPoultryEnabled
      ? this.getFlockBaseUrl(variant)
      : `${this.legacyBaseUrl}/animalcountcard`;
  }

  get animalCountBaseUrl(): string {
    return this.getAnimalCountBaseUrl();
  }

  get deliveryLineBaseUrl(): string {
    return this.isPoultryEnabled
      ? `${this.poultryBaseUrl}/layers/delivery-line`
      : `${this.legacyBaseUrl}/delivery-line`;
  }

  get benchmarkBaseUrl(): string {
    return this.isPoultryEnabled
      ? `${this.poultryBaseUrl}/public/secure/benchmark`
      : `${this.legacyBaseUrl}/benchmark`;
  }

  get porphyrioBenchmarkBaseUrl(): string {
    return this.isPoultryEnabled
      ? `${this.poultryBaseUrl}/layers/porphyrio-benchmark`
      : `${this.legacyBaseUrl}/porphyriobenchmark`;
  }

  get sustainabilityBaseUrl(): string {
    return `${this.poultryBaseUrl}/public/secure/sustainability`;
  }

  getHatcheryUrl(variant: FlockVariant = FLOCK_VARIANT.Layer): string {
    const animalType = variant === FLOCK_VARIANT.Breeder ? 'Breeder' : 'Layer';
    return `${this.env.API_BASE_URL}/service/hatchery/secure/hatchery?animalType=${animalType}`;
  }

  getRearingOrganizationsUrl(): string {
    return `${this.poultryBaseUrl}/breeders/rearing-organizations`;
  }
}
